import * as React from "react";
import { Provider } from "jotai";
import { QueryParamProvider } from "use-query-params";
import { ErrorBoundary } from "@sentry/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import { Logo } from "@/components/ui/Logo";

import { ErrorFallback } from "@/features/_misc/ErrorFallback";

import { QsUtils } from "@/utils/qs";
import { queryClient } from "@/utils/remote";

import { ReactRouterQueryParamAdapter } from "./ReactRouterQueryParamAdapter";
import { TranslationProvider } from "./TranslationProvider";

type AppProviderProps = {
  children: React.ReactNode;
};

export const AppProvider = ({ children }: AppProviderProps) => {
  return (
    <Provider>
      <React.Suspense
        fallback={
          <div
            className="flex min-h-dvh w-screen items-center justify-center pb-10"
            data-testid={"app-loading"}
          >
            <Logo dark />
          </div>
        }
      >
        <ErrorBoundary fallback={ErrorFallback}>
          <QueryParamProvider
            adapter={ReactRouterQueryParamAdapter}
            options={QsUtils.getQueryParamFormatter()}
          >
            <QueryClientProvider client={queryClient}>
              <TranslationProvider>{children}</TranslationProvider>
              <ReactQueryDevtools initialIsOpen={false} />
            </QueryClientProvider>
          </QueryParamProvider>
        </ErrorBoundary>
      </React.Suspense>
    </Provider>
  );
};
